import { render } from "./LayoutMinimal.vue?vue&type=template&id=2d77c5c3&scoped=true"
import script from "./LayoutMinimal.vue?vue&type=script&lang=js"
export * from "./LayoutMinimal.vue?vue&type=script&lang=js"

import "./LayoutMinimal.vue?vue&type=style&index=0&id=2d77c5c3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d77c5c3"]])

export default __exports__